<template>
  <v-row justify="center">
    <v-dialog persistent v-model="this._props.addDialogCfop" max-width="600">
      <v-card>
        <v-card-title primary-title>CFOP</v-card-title>
        <v-container>
          <v-divider></v-divider>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="submit"
            class="mt-6"
          >
            <v-col>
              <v-text-field
                label="Codigo"
                v-model="code"
                :rules="[
                  () => !!code || 'Campo Obrigatorio',
                  () =>
                    (!!code && code.length == 4) ||
                    'Campo tem que ser igual a 4'  
                ]"
                type="number"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                maxlength="4"
                outlined
              ></v-text-field>
            </v-col>
            <v-col>
              <v-textarea
                label="Descrição"
                v-model="description"
                :rules="[() => !!description || 'Campo Obrigatorio']"
                outlined
              />
            </v-col>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="error"
                @click="
                  () => {
                    closeCfop();
                    //runAlterDialog(this, alterAddDialog);
                  }
                "
                >Cancelar</v-btn
              >
              <v-btn
                color="success"
                class="mr-4"
                :disabled="!valid"
                @click="
                  () => {
                    submit();
                  }
                "
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mdiAccount } from "@mdi/js";

import { ADD_CFOP, UPDATE_CFOP } from "../../../store/actions/cfop";
export default {
  props: {
    addDialogCfop: Boolean,
    component: Object,
  },

  data() {
    return {
      attrs: false,
      on: false,
      id: "",
      code: "",
      valid: true,
      updated_at: "",
      created_at: "",
      search: "",
      description: "",
      svgPath: mdiAccount,
      formHasErrors: false,
    };
  },
  methods: {
    closeCfop() {
      this.component.addDialogCfop = false;
    },
    getComponent() {
      return this._props.component;
    },
    async create_cfop() {
      const cfop = {
        code: this.code,
        description: this.description,
      };
      try {
        await this.$store.dispatch(ADD_CFOP, cfop);
        this.closeCfop();
      } catch (error) {
        alert(error);
      }
    },
    submit() {
      this.id == undefined ? this.create_cfop() : this.update_cfop();
      this.component.addDialog = false;
    },
    async update_cfop() {
      const cfop = {
        id: this.id,
        code: this.code,
        description: this.description,
      };
      try {
        await this.$store.dispatch(UPDATE_CFOP, cfop);
      } catch (error) {
        alert(error);
      }
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
  async created() {
    this.object = { ...this.getComponent().objectToUpdate };
    this.id = this.object.id;
    this.description = this.object.description;
    this.code = this.object.code;
  },
  beforeDestroy() {
    this.getComponent().objectToUpdate = {};
  },
};
</script>
